export default __webpack_public_path__ + "static/media/admin.f4f0f0cc.jpg";